import {
    FETCH_APPLICATION_LIST,
    FETCH_APPLICATION_LIST_SUCCESS,
    FETCH_APPLICATION_LIST_ERROR,
    SET_APPLICATIONS_SEARCH_TERM,
    UPDATE_NOTIFICATION,
    UPDATE_NOTIFICATION_SUCCESS,
    UPDATE_NOTIFICATION_ERROR,
    FETCH_NOTIFICATION_LIST,
    FETCH_NOTIFICATION_LIST_SUCCESS,
    FETCH_NOTIFICATION_LIST_ERROR,
} from './constants';

const initialState = {
    list: {
        searchTerm: '',
        data: [],
        hasError: false,
        isLoading: false,
    },
    notifications: {
        isLoading: false,
        hasError: false,
        data: [],
        page: {
            total: 0,
            after: '',
            limit: 0,
        },
    },
    organizations: {
        data: [],
        isFailed: false,
        isLoading: false,
    },
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_APPLICATIONS_SEARCH_TERM:
            return {
                ...state,
                list: {
                    ...state.list,
                    searchTerm: payload.searchTerm,
                },
            };

        case FETCH_APPLICATION_LIST:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: false,
                    isLoading: true,
                },
            };

        case FETCH_APPLICATION_LIST_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    data: payload.data,
                    isLoading: false,
                    hasError: false,
                },
            };

        case FETCH_APPLICATION_LIST_ERROR:
            return {
                ...state,
                list: {
                    ...state.list,
                    isLoading: false,
                    hasError: true,
                },
            };

        case FETCH_NOTIFICATION_LIST:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    isLoading: true,
                    hasError: false,
                },
            };

        case FETCH_NOTIFICATION_LIST_SUCCESS:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    isLoading: false,
                    hasError: false,
                    data: payload,
                },
            };

        case FETCH_NOTIFICATION_LIST_ERROR:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    isLoading: false,
                    hasError: true,
                },
            };

        case UPDATE_NOTIFICATION:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    isLoading: true,
                    hasError: false,
                },
            };

        case UPDATE_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    data: state.notifications.data.map((notification) => {
                        if (notification.businessKey === payload.notificationId) {
                            return {
                                ...notification,
                                ...payload.data.payload,
                            };
                        }

                        return notification;
                    }),
                },
            };

        case UPDATE_NOTIFICATION_ERROR:
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    isLoading: false,
                    hasError: true,
                },
            };

        default:
            return state;
    }
};

export default reducer;
